import { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import * as Actions from 'flex/Actions';
import { ListContext } from '../index';


function TermEffectComponent(props) {
    const [list, setList] = useContext(props.context ? props.context : ListContext);
    const termSearchConnection = useSelector(state => state.termSearchConnection);

    useEffect(() => {
        const { meta, payload: { result } } = termSearchConnection;
        switch (meta.status) {
            case Actions.statusEnum.SUCCESS:
                setList({
                    ...list,
                    termList: result.items,
                    termListItemCount: result.item_count
                });
                break;
            //OPTIMIZE 基本的には汎用エラーコンポーネントがエラーをスポイルしてここでは何も起こらないのが正なので、処理しない
            case Actions.statusEnum.FAILURE: case Actions.statusEnum.ERROR:
            default:
                break;
        }
    }, [termSearchConnection]);// eslint-disable-line

    return null;
};

export default TermEffectComponent;
